import { useDispatch, useSelector } from "react-redux";
import { useServices } from "../core-ui/ServiceProvider";
import { requestDelete, requestUpdate } from "../services/ChangeService";
const callAndAccumulate = (accumulator, fn) => (...args) => {
    const result = fn(...args);
    accumulator.set(result.id, result);
    return result;
};
const provideTreeModel = (options) => {
    const { ChangeService, ProjectService, ResourceTreeService, WorkspaceService } = useServices();
    const dispatch = useDispatch();
    const { resources } = useSelector(ProjectService.selectors.getProject);
    const resourceTypes = useSelector(ProjectService.selectors.getResourceTypes);
    const selectedResourceID = useSelector(ResourceTreeService.selectors.getSelectedResourceID);
    if (Object.values(resources).length === 0) {
        return {
            itemById: () => undefined,
            tree: () => [],
            selectedItem: () => undefined,
        };
    }
    const resourcesByType = Object.values(resources).reduce((resourceTypeBuckets, resource) => ({
        ...resourceTypeBuckets,
        [resource.typeID]: [...(resourceTypeBuckets[resource.typeID] || []), resource],
    }), {});
    const treeItemsByID = new Map();
    const resourceToTreeItem = callAndAccumulate(treeItemsByID, (resourceType, dispatch, serializedResource) => ({
        id: serializedResource.id,
        ancestorIds: [resourceType.id],
        editable: true,
        icon: resourceType.icon,
        label: serializedResource.name,
        actions: [
            { id: 'editor:open', label: 'Open', run: () => dispatch(WorkspaceService.openResource(serializedResource.id)) },
            {
                id: 'rename',
                label: 'Rename',
                hotkey: 'F2',
                async: true,
                run: (name) => dispatch(ChangeService.commit(requestUpdate({
                    changeLabel: 'Rename',
                    resource: { ...serializedResource, name },
                    origin: 'global',
                }))),
            },
            {
                id: 'delete',
                label: 'Delete',
                hotkey: 'Delete',
                run: () => dispatch(ChangeService.commit(requestDelete({
                    resource: serializedResource,
                    origin: 'global',
                }))),
            },
        ],
        onSelect: () => dispatch(WorkspaceService.openResource(serializedResource.id)),
    }));
    const resourceTypeToTreeItem = callAndAccumulate(treeItemsByID, (resourceType, dispatch, resourcesOfType = []) => ({
        id: resourceType.id,
        ancestorIds: [],
        label: resourceType.pluralName,
        // @TODO localize this number
        endContent: resourcesOfType.length ? `${resourcesOfType.length}` : undefined,
        onSelect: () => { },
        styledStrong: true,
        children: resourcesOfType.map(resourceToTreeItem.bind(null, resourceType, dispatch)),
    }));
    const tree = Object.values(resourceTypes)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((resourceType) => resourceTypeToTreeItem(resourceType, dispatch, resourcesByType[resourceType.id]));
    return {
        itemById: (id) => treeItemsByID.get(id),
        selectedItem: () => treeItemsByID.get(selectedResourceID),
        tree: () => tree,
    };
};
const ResourceTreeProvider = {
    provideTreeModel,
};
export default ResourceTreeProvider;
//# sourceMappingURL=ResourceTreeProvider.js.map